import {
	FormControl,
	FormLabel,
	Heading,
	Input,
	Stack,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useUserContext } from "../../hooks/use-user-context";
import { PostLoginOnboardingStepsProps } from "./post-login-onboarding";
import { useEffect, useState } from "react";
import { isNullOrWhiteSpace } from "../../utils/string-helper";
import { useTranslation } from "react-i18next";
import { useUpdateUserQuery } from "../../hooks/use-update-user-query";
import { personalInfoSchema } from "../../models/user";

export const PostLoginOnboardningAdress = ({ setContinueButton }: PostLoginOnboardingStepsProps) => {
	const { user } = useUserContext();
	const { t } = useTranslation();
	const { saveUserAsync } = useUpdateUserQuery(
		personalInfoSchema.pick({ address: true, coAddress: true, zip: true, city: true }),
	);

	const [address, setAddress] = useState(user?.address);
	const [addressInvalid, setAddressInvalid] = useState(false);
	const [coAddress, setCoAddress] = useState(user?.coAddress);
	const [zip, setZip] = useState(user?.zip);
	const [zipInvalid, setZipInvalid] = useState(false);
	const [city, setCity] = useState(user?.city);
	const [cityInvalid, setCityInvalid] = useState(false);

	useEffect(() => {
		const save = async () => {
			const haveChanges =
				address !== user?.address ||
				coAddress !== user?.coAddress ||
				zip !== user?.zip ||
				city !== user?.city;

			if (haveChanges) {
				return await saveUserAsync({ address, coAddress, zip, city });
			} else {
				return true;
			}
		};

		setContinueButton({
			isDisabled: isNullOrWhiteSpace(address) || isNullOrWhiteSpace(zip) || isNullOrWhiteSpace(city),
			save: save,
		});
	}, [address, city, setContinueButton, zip, coAddress, user, saveUserAsync]);

	const isEmpty =
		isNullOrWhiteSpace(user?.address) &&
		isNullOrWhiteSpace(user?.coAddress) &&
		isNullOrWhiteSpace(user?.zip) &&
		isNullOrWhiteSpace(user?.city);

	return (
		<Stack gap={ThemeSpaceVariable.Large}>
			<Heading as="h1">
				{isEmpty ? t("post_login_onboarding_adress_title_empty") : t("post_login_onboarding_adress_title")}
			</Heading>
			<Stack gap={ThemeSpaceVariable.Medium}>
				<FormControl isInvalid={addressInvalid} isRequired>
					<FormLabel>{t("profile_address")}</FormLabel>
					<Input
						value={address}
						onChange={(e) => setAddress(e.target.value)}
						placeholder="Storgatan 1"
						onBlur={(e) => setAddressInvalid(isNullOrWhiteSpace(e.target.value))}
						size={"lg"}
					/>
				</FormControl>
				<FormControl>
					<FormLabel>{t("profile_coAddress")}</FormLabel>
					<Input value={coAddress} onChange={(e) => setCoAddress(e.target.value)} size={"lg"} />
				</FormControl>
				<FormControl isInvalid={zipInvalid} isRequired>
					<FormLabel>{t("profile_zip")}</FormLabel>
					<Input
						value={zip}
						onChange={(e) => setZip(e.target.value)}
						placeholder="123 45"
						size={"lg"}
						onBlur={(e) => setZipInvalid(isNullOrWhiteSpace(e.target.value))}
					/>
				</FormControl>
				<FormControl isInvalid={cityInvalid} isRequired>
					<FormLabel>{t("profile_city")}</FormLabel>
					<Input
						value={city}
						onChange={(e) => setCity(e.target.value)}
						placeholder="Uppsala"
						size={"lg"}
						onBlur={(e) => setCityInvalid(isNullOrWhiteSpace(e.target.value))}
					/>
				</FormControl>
			</Stack>
		</Stack>
	);
};
